// G2 Inspections (interface) : inscription du module. Les fichiers centraux (routeur, pages, navigation)
// reçoivent une ligne par module à l'intégration.

import { createElement } from 'react';
import { AccueilInspecteur } from './AccueilInspecteur';
import { FicheInspection } from './FicheInspection';
import { ListeInspections, ModelesFormulaire, PlanifierInspection } from './Inspections';

export const inscription = {
  code: 'G2',
  routes: [
    { chemin: '/inspections', element: createElement(ListeInspections) },
    { chemin: '/inspections/planifier', element: createElement(PlanifierInspection) },
    { chemin: '/inspections/formulaires', element: createElement(ModelesFormulaire) },
    { chemin: '/inspections/:id', element: createElement(FicheInspection) },
  ],
  /** Accueil du profil « inspecteur » (artboard P04), à brancher dans l'accueil par profil à l'intégration. */
  accueil: { profil: 'inspecteur', element: createElement(AccueilInspecteur) },
} as const;

export { FormulaireGenerique } from './FormulaireGenerique';
export { BlocSynchronisation } from './Synchronisation';
